

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { GoogleGenerativeAI } from '@google/generative-ai';

@Injectable({
  providedIn: 'root',
})
export class GeminiService {
  knowledgeBase:any
  private generativeAI: GoogleGenerativeAI;
  private messageHistory: BehaviorSubject<any> = new BehaviorSubject(null);
  constructor() {
    this.generativeAI = new GoogleGenerativeAI('AIzaSyBaerxumcND2jj--YG-FV2Oze365d4QDnE');
  }

  async generateText(prompt: string) {
    const model = this.generativeAI.getGenerativeModel({ model: 'gemini-1.5-flash' });
    this.messageHistory.next({
      from: 'user',
      message: prompt
    });

    const result = await model.generateContent(prompt);
    const response = await result.response;
    const text = response.text();
    console.log(text);
    this.messageHistory.next({
      from: 'bot',
      message: text
    })
  }

  public getMessageHistory(): Observable<any> {
    return this.messageHistory.asObservable();
  }


  

    async generateCustomResponse(prompt: string,trainingdata:any,previouschat:any): Promise<void> {
      console.log(prompt);
      
      console.log(trainingdata);
    let promptString = `You are an Ai assistant responsible for addressing questions and clarifying doubts from your colleagues with precision and professionalism. Your task is to provide clear and concise answers solely based on the TEXT CONTENT provided. Follow these guidelines when responding:  
    **Tracking Context**:
- If a new question is provided and you believe it is related to a previous chat history.previous chat history is in array form:"${previouschat}", you may cross-reference it with the following:
  - current question: "${prompt}"
  - Check whether the current question logically follows from or references the chat history-${previouschat} . - if it is,generate answer from the ${trainingdata} .else reply "The answer for the give question is not avaliable in this document section."
  - answer like an ai give reply to the question,dont mention the "the provided text"


1. **TEXT CONTENT-Based Responses**:
   - If the QUESTION CONTENT is directly related to the TEXT CONTENT, provide a well-structured and precise answer based only on the information available in the TEXT CONTENT.

2. **No Information Available**:
   - If the TEXT CONTENT does not contain any answer related to the QUESTION CONTENT , respond with:
     "No information is available about [insert the QUESTION CONTENT] currently.
     otherwise reply answer based on 'trainingdata provided'"

3. **General Conversations**:
   - If the QUESTION CONTENT is casual (e.g., "Hi", "How are you?", etc.), respond as a conversational AI assistant, engaging politely and asking how you can assist.

4. **Requests to Modify TEXT CONTENT**:
   - If the QUESTION CONTENT involves requests to modify or change the section (e.g., changing sections, categories, or departments), respond with:
     "Reference document changed."

5. **Questions About You**:
   - If the QUESTION CONTENT is about your role, respond with:
     "I am an AI assistant designed to answer your questions based on the TEXT CONTENT available in my registry."


     **IMPORTANT NOTES**:
- Avoid prefacing your responses with phrases like "Based on the provided text."
- Be direct, clear, and contextual in your answers.
Here is the provided **TEXT CONTENT** from which answers should be derived:
${trainingdata}  

Here is the **QUESTION CONTENT** for which a response is required:
${prompt}  

`;
  
    const enhancedPrompt = `${promptString}`;
    const model = this.generativeAI.getGenerativeModel({ model: 'gemini-1.5-flash' });
    this.messageHistory.next({
      from: 'user',
      message: prompt
    });
    const result = await model.generateContent(enhancedPrompt);
    const response = await result.response;
    const text = await response.text();

    this.messageHistory.next({
      from: 'user',
      message: text
    });
    console.log(text);
  }

  /**
   * AI Verification for Trade License / Mulkiya documents.
   * Analyzes uploaded document file with Gemini Vision, extracts details,
   * and matches the license number against user input.
   */
  async verifyTradeLicense(file: File, userLicenseNo?: string): Promise<TradeLicenseAiResult> {
    try {
      const base64Data = await this.fileToBase64Data(file);
      let mimeType = file.type;
      if (!mimeType || mimeType === 'application/octet-stream') {
        const ext = file.name.split('.').pop()?.toLowerCase();
        if (ext === 'pdf') mimeType = 'application/pdf';
        else if (ext === 'png') mimeType = 'image/png';
        else if (ext === 'webp') mimeType = 'image/webp';
        else mimeType = 'image/jpeg';
      }

      const prompt = `You are an AI document verification system for UAE businesses and economic departments (Dubai DED, Abu Dhabi ADDED, Sharjah SEDD, RAK, Ajman, Fujairah, UAQ, Ministry of Economy, Mulkiya vehicle/equipment registration cards, commercial licenses, etc.).

Analyze the provided document file carefully:
1. Determine if this document is a valid UAE Trade License, Commercial License, Business Registration Certificate, or Mulkiya (equipment/vehicle registration card). If it is a generic photo, selfie, animal, receipt, invoice, or unrelated file, set "isValidDocument" to false.
2. Extract the Trade License Number, Commercial License No, Registration No, or Mulkiya Traffic Code / Registration Number from the document.
3. Extract Company Name or Business Name if present.
4. Extract License Expiry Date if present.
5. Extract Issuing Authority if present.

Return ONLY a raw JSON object string (NO markdown formatting, NO backticks):
{
  "isValidDocument": boolean,
  "documentType": string,
  "extractedLicenseNumber": string,
  "companyName": string,
  "expiryDate": string,
  "issuedBy": string,
  "reason": string
}`;

      const model = this.generativeAI.getGenerativeModel({ model: 'gemini-1.5-flash' });
      const imagePart = {
        inlineData: {
          data: base64Data,
          mimeType: mimeType
        }
      };

      const result = await model.generateContent([prompt, imagePart]);
      const response = await result.response;
      let text = response.text().trim();

      // Clean markdown code blocks if any (e.g. ```json ... ```)
      text = text.replace(/^```json\s*/i, '').replace(/^```\s*/, '').replace(/\s*```$/, '').trim();

      let aiJson: any = {};
      try {
        aiJson = JSON.parse(text);
      } catch (e) {
        console.warn('Failed to parse Gemini JSON response:', text);
        aiJson = {
          isValidDocument: true,
          extractedLicenseNumber: '',
          reason: 'Document uploaded'
        };
      }

      if (!aiJson.isValidDocument) {
        return {
          isValidDocument: false,
          isMatch: false,
          message: aiJson.reason || 'Uploaded file does not appear to be a valid Trade License or Mulkiya document.',
          rawReason: aiJson.reason
        };
      }

      const extractedNo = (aiJson.extractedLicenseNumber || '').trim();
      const normExtracted = this.normalizeLicenseNo(extractedNo);
      const normUser = this.normalizeLicenseNo(userLicenseNo || '');

      let isMatch = true;
      let message = 'Trade License verified successfully.';

      if (userLicenseNo && userLicenseNo.trim().length > 0) {
        if (normExtracted && normUser) {
          const matches = normUser === normExtracted ||
                          normUser.includes(normExtracted) ||
                          normExtracted.includes(normUser) ||
                          this.fuzzyLicenseMatch(normUser, normExtracted);
          if (!matches) {
            isMatch = false;
            message = `The entered Trade License number ("${userLicenseNo}") and the uploaded document number ("${extractedNo}") do not match.`;
          }
        }
      }

      return {
        isValidDocument: true,
        documentType: aiJson.documentType || 'Trade License / Mulkiya',
        extractedLicenseNumber: extractedNo,
        companyName: aiJson.companyName || '',
        expiryDate: aiJson.expiryDate || '',
        issuedBy: aiJson.issuedBy || '',
        isMatch: isMatch,
        message: message,
        rawReason: aiJson.reason
      };

    } catch (err: any) {
      console.error('Gemini Trade License AI verification error:', err);
      return {
        isValidDocument: true,
        isMatch: true,
        message: 'AI verification warning: Could not verify document automatically.'
      };
    }
  }

  private fileToBase64Data(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        const base64 = result.includes(',') ? result.split(',')[1] : result;
        resolve(base64);
      };
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(file);
    });
  }

  public normalizeLicenseNo(str: string): string {
    if (!str) return '';
    return str.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  }

  public fuzzyLicenseMatch(num1: string, num2: string): boolean {
    if (!num1 || !num2) return false;
    const d1 = num1.replace(/\D/g, '');
    const d2 = num2.replace(/\D/g, '');
    if (d1.length >= 3 && d2.length >= 3) {
      return d1 === d2 || d1.includes(d2) || d2.includes(d1);
    }
    return false;
  }
}

export interface TradeLicenseAiResult {
  isValidDocument: boolean;
  documentType?: string;
  extractedLicenseNumber?: string;
  companyName?: string;
  expiryDate?: string;
  issuedBy?: string;
  isMatch?: boolean;
  message?: string;
  rawReason?: string;
}